import React from 'react';
import styles from './About.module.css';
import ahmedImage from '../../assets/images/ahmed.png';
import hodaImage from '../../assets/images/70da.png';

function About({ lang }) {
  const t = {
    en: {
      storyTitle: 'Our Story',
      story1: `We started with one mission — to bring bold, stylish, and comfortable clothing to people who are often overlooked by the fashion industry.\nFrom Istanbul to Riyadh to Berlin, we’re here to celebrate every body and make sure confidence comes in every size.`,
      story2: `We're not just building a brand — we're building a movement that redefines style, fit, and self-expression. 🚀✨`,
      team: 'Our Team',
      missionTitle: 'Our Mission',
      mission: `To empower plus-size individuals across Turkey, the Gulf, and Europe with fashion that fits, feels great, and looks even better.\nWe’re on a mission to break stereotypes and prove that style has no size limits.`,
      valuesTitle: 'Our Values',
      values: [
        'Inclusivity – We create fashion that embraces all body types.',
        'Confidence – We design clothes that make you feel good in your own skin.',
        'Quality – Every piece is crafted with care, durability, and comfort in mind.',
        'Boldness – We don’t follow trends we set them.'
      ],
      visionTitle: 'Our Vision',
      vision: `To become the leading plus-size fashion brand across our markets — a name synonymous with style, inclusivity, and confidence.\nWhether it’s everyday wear or standout streetwear, 2nice is here to help you own your look.`
    },
    ar: {
      storyTitle: 'قصتنا',
      story1: `بدأنا بهدف واحد — تقديم ملابس جريئة وعصرية ومريحة للأشخاص الذين غالبًا ما يتجاهلهم عالم الموضة.\nمن اسطنبول إلى الرياض إلى برلين، نحن هنا لنحتفل بكل الأجسام ونجعل الثقة متاحة للجميع.`,
      story2: `نحن لا نبني علامة تجارية فقط — نحن نبني حركة تعيد تعريف الأسلوب والمقاس والتعبير عن الذات. 🚀✨`,
      team: 'فريقنا',
      missionTitle: 'مهمتنا',
      mission: `تمكين أصحاب المقاسات الكبيرة في تركيا والخليج وأوروبا بموضة تناسبهم وتشعرهم بالراحة والثقة.\nمهمتنا كسر الصور النمطية وإثبات أن الأناقة لا حدود لها.`,
      valuesTitle: 'قيمنا',
      values: [
        'الشمولية – نصنع أزياء تحتضن جميع الأجسام.',
        'الثقة – نصمم ملابس تجعلك تشعر بالرضا عن نفسك.',
        'الجودة – كل قطعة مصنوعة بعناية ومتانة وراحة.',
        'الجرأة – لا نتبع الموضة بل نصنعها.'
      ],
      visionTitle: 'رؤيتنا',
      vision: `أن نصبح العلامة الرائدة في مجال أزياء المقاسات الكبيرة في أسواقنا — اسم مرادف للأناقة والشمولية والثقة.\nسواء كانت ملابس يومية أو ستريت وير مميزة، 2nice هنا لتساعدك على إبراز إطلالتك.`
    },
    tr: {
      storyTitle: 'Hikayemiz',
      story1: `Bir misyonla başladık — moda endüstrisi tarafından çoğu zaman göz ardı edilen insanlara cesur, şık ve rahat kıyafetler sunmak.\nİstanbul'dan Riyad'a, Berlin'e kadar her bedeni kutlamak ve özgüveni her bedene taşımak için buradayız.`,
      story2: `Sadece bir marka inşa etmiyoruz — tarzı, uyumu ve kendini ifade etmeyi yeniden tanımlayan bir hareket inşa ediyoruz. 🚀✨`,
      team: 'Ekibimiz',
      missionTitle: 'Misyonumuz',
      mission: `Türkiye, Körfez ve Avrupa'daki büyük beden bireyleri, onlara uyan, harika hissettiren ve daha da iyi görünen modayla güçlendirmek.\nStereotipleri yıkmak ve stilin bedeni olmadığını kanıtlamak için buradayız.`,
      valuesTitle: 'Değerlerimiz',
      values: [
        'Kapsayıcılık – Tüm vücut tiplerini kucaklayan moda yaratıyoruz.',
        'Özgüven – Kendi teninizde iyi hissettiren kıyafetler tasarlıyoruz.',
        'Kalite – Her parça özenle, dayanıklılık ve konforla üretilir.',
        'Cesaret – Modayı takip etmiyoruz, biz belirliyoruz.'
      ],
      visionTitle: 'Vizyonumuz',
      vision: `Pazarlarımızda lider büyük beden moda markası olmak — stil, kapsayıcılık ve özgüvenle eş anlamlı bir isim.\nGünlük giyimden sokak modasına, 2nice görünümünüze sahip çıkmanız için burada.`
    }
  }[lang];

  const teamMembers = [
    {
      name: "Ahmed Awad",
      role: "web developer & CEO",
      image: ahmedImage
    },
    {
      name: "Hazem Ahmed",
      role: "Founder & CEO",
      image: hodaImage
    }
  ];

  return (
    <div className={styles.about}>
      <div className={styles.container}>
        {/* Story Section */}
        <section className={styles.storySection}>
          <div className={styles.content}>
            <h1>{t.storyTitle}</h1>
            <p>{t.story1}</p>
            <p>{t.story2}</p>
          </div>
        </section>

        {/* Team Section */}
        <section className={styles.teamSection}>
          <h2>{t.team}</h2>
          <div className={styles.teamGrid}>
            {teamMembers.map((member, index) => (
              <div key={index} className={styles.teamCard}>
                <div className={styles.teamImage}>
                  <img src={member.image} alt={member.name} />
                </div>
                <h3>{member.name}</h3>
                <p>{member.role}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Mission, Values, Vision Grid */}
        <section className={styles.infoGrid}>
          <div className={styles.infoCard}>
            <h2>{t.missionTitle}</h2>
            <p>{t.mission}</p>
          </div>

          <div className={styles.infoCard}>
            <h2>{t.valuesTitle}</h2>
            <ul>
              {t.values.map((value, index) => (
                <li key={index}>{value}</li>
              ))}
            </ul>
          </div>

          <div className={styles.infoCard}>
            <h2>{t.visionTitle}</h2>
            <p>{t.vision}</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About; 